import React, { ChangeEvent, FC } from 'react'

import clsx from 'clsx'

interface FurtherRemarksInputProps {
  editable: boolean
  furtherRemarksValue: string
  onChangeFurtherRemarks: (e: ChangeEvent<HTMLTextAreaElement>) => void
}
export const FurtherRemarksInput: FC<FurtherRemarksInputProps> = ({
  editable,
  furtherRemarksValue,
  onChangeFurtherRemarks,
}) => {
  return (
    <div className="border-t border-SeabiscuitLightThemeColorD3 mt-6 mb-4 pt-4">
      <h4 className="text-[20px]">Further remarks</h4>
      <textarea
        disabled={!editable}
        placeholder={editable ? 'Enter remarks...' : 'No remarks'}
        className={clsx(
          'mt-4 bg-SeabiscuitGrayThemeColor rounded-md w-full h-52 border border-SeabiscuitLightThemeColorD3',
          furtherRemarksValue || !editable ? 'bg-SeabiscuitGrayThemeColor' : 'bg-white'
        )}
        value={furtherRemarksValue}
        onChange={onChangeFurtherRemarks}
      />
    </div>
  )
}
